import axios from 'axios'

let checkInterface = url => {
    if (process.env.NODE_ENV === 'production') {
        if (/^\/api/.test(url)) {
            return '/loyaltyApi/api' + url.replace(/^\/api/, '')
        } else if (/^\/pro/.test(url)) {
            return '/creditmall/api' + url.replace(/^\/pro/, '')
        } else {
            return url
        }
    } else {
        return url
    }
}

class HttpRequest {
    constructor (baseUrl) {
        this.baseUrl = baseUrl
    }
    getInsideConfig () {
        return {
            baseURL: this.baseUrl,
            headers: {}
        }
    }
    interceptors (instance) {
        // 请求拦截
        instance.interceptors.request.use(config => {
            // 添加全局的loading...
            // do something
            return config
        }, error => {
            return Promise.reject(error)
        })
        // 响应拦截
        instance.interceptors.response.use(res => {
            const { data, status } = res
            return { data, status }
        }, error => {
            return Promise.reject(error)
        })
    }
    request (options) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(), options)
        options.url = checkInterface(options.url)
        this.interceptors(instance, options.url)
        return instance(options)
    }
}
export default HttpRequest
